import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

const RACE_DETAILS_HEADER_HEIGHT_XS = 49;

export default makeStyles((theme: MuiTheme) => ({
  bookContainer: {
    width: "100%",
    height: "100%",
    display: "grid",
    gridAutoColumns: "minmax(0, 1fr)",
    gridAutoFlow: "column",
    gap: 20,
    [theme.breakpoints.down("md")]: {
      gap: 12
    },
    [theme.breakpoints.down("xs")]: {
      gap: 0
    }
  },
  paper: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)",
    position: "relative"
  },
  paperContent: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column"
  },
  tabContent: {
    [theme.breakpoints.down("xs")]: {
      overflowY: "hidden",
      height: "100%",
      paddingBottom: 50
    }
  },
  leftPaper: {
    position: "relative"
  },
  rightPaper: {
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      backgroundColor: "white",
      top: "-56px",
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1300,
      borderRadius: 0
    }
  },
  tabs: {
    position: "sticky",
    top: 0,
    backgroundColor: theme.palette.common.white,
    zIndex: 1,
    [theme.breakpoints.down("xs")]: {
      minHeight: 40,
      backgroundColor: theme.palette.common.white
    }
  },
  tab: {
    textTransform: "none",
    fontSize: 20,
    borderBottom: "2px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      padding: "0 12px",
      minHeight: 40
    }
  },
  accordion: {},
  expRoot: {
    boxShadow: "none",
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      "&.indexAccordion, &.conditionsAccordion": {
        marginTop: 8,
        border: "none",
        boxShadow: "0px 1px 7px 0px #0000001a",
        "&.Mui-expanded": {
          marginTop: 8,
          "&:first-child": {
            marginTop: 8
          }
        }
      }
    }
  },
  expDisabled: {
    [theme.breakpoints.down("xs")]: {
      marginTop: 8
    }
  },
  accordionSummary: {
    "& .MuiIconButton-root": {
      color: "#595a5a"
    }
  },
  sumRoot: {
    padding: "0px 20px",
    "&.Mui-expanded": {
      borderBottom: "none"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0px 12px"
    }
  },
  sumRootExpanded: {
    marginBottom: "0 !important"
  },
  summaryContent: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  summaryTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: 16,
    width: "100%"
  },
  summaryTitleConditions: {
    justifyContent: "space-between"
  },
  dayName: {
    color: "#333333",
    fontWeight: 600,
    marginRight: 4,
    [theme.breakpoints.down("xs")]: {
      fontSize: 14,
      lineHeight: 1,
      whiteSpace: "nowrap"
    }
  },
  dayDate: {
    color: "#808080",
    textAlign: "right",
    [theme.breakpoints.down("xs")]: {
      fontSize: 13,
      lineHeight: 1
    }
  },
  accordionDetails: {
    display: "flex",
    flexDirection: "column",
    padding: "4px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: "6px 12px"
    }
  },
  dayDetailsList: {
    lineHeight: 1.6
  },
  dayDetail: {
    display: "flex",
    fontSize: 12
  },
  dayDetailTitle: {
    marginRight: 6,
    color: "#333333",
    fontWeight: 600
  },
  dayDetailText: {
    color: "#808080"
  },
  dayRaceList: {
    marginTop: 10
  },
  raceContainer: {
    padding: 14,
    border: "1px solid #dbdbdb",
    marginTop: 4,
    overflow: "hidden",
    position: "relative"
  },
  raceContainerMatched: {
    borderColor: "#d2c5a5"
  },
  raceContainerSelected: {
    borderColor: "#103827",
    backgroundColor: "#03f3b20d"
  },
  typeChallenge: {},

  detailsLinkContainer: {
    position: "absolute",
    width: 54,
    height: 54,
    right: -27,
    top: -27,
    transform: "rotate(45deg)",
    backgroundColor: "#eeeeee80",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    border: "1px solid #eeeeee",
    "&:hover": {
      cursor: "pointer"
    }
  },
  detailsLinkContainerMatched: {
    backgroundColor: "#f0e3bf",
    border: "1px solid #d2c5a5",
    "& .MuiSvgIcon-root": {
      color: "#403d33"
    }
  },
  detailsLinkContainerSelected: {
    backgroundColor: theme.palette.secondary.main,
    border: "1px solid #2d6c51",
    "& .MuiSvgIcon-root": {
      color: "#103827",
      transform: "rotate(90deg)"
    }
  },

  linkArrow: {
    transform: "rotate(-90deg)",
    color: "#7d7d7d",
    fontSize: 20
  },
  linkArrowMatched: {},
  linkArrowSelected: {},

  raceHeader: {
    display: "flex",
    marginBottom: 6
  },
  index: {
    fontSize: 38,
    fontWeight: 600,
    marginRight: 10,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    height: 36
  },
  title: {
    fontSize: 14,
    lineHeight: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around"
  },
  mainTitle: {
    fontWeight: 600
  },
  subtitle: {},
  raceBody: {},
  raceDetails: {
    marginTop: 6,
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: 13
  },
  stakesDetails: {
    marginTop: 6,
    color: theme.palette.text.primary,
    fontSize: 13
  },
  stakesBoldDetails: {
    fontWeight: 600,
    marginRight: 6
  },
  stakesRegularDetails: {},
  stakeRaceName: {
    fontWeight: 600,
    fontSize: 16,
    display: "flex",
    justifyContent: "center",
    textAlign: "center"
  },
  stakeRacePurseGarantGrade: {
    fontWeight: 600
  },
  distance: {
    marginTop: 6,
    display: "flex",
    lineHeight: 1
  },
  nominationClose: {
    fontWeight: 600
  },
  marginBottom: {
    marginBottom: 20
  },
  distanceTitle: {
    fontWeight: 600,
    marginRight: 4
  },
  groups: {
    marginTop: 6
  },
  raceGroup: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    marginBottom: 4,
    alignItems: "flex-end"
  },
  groupName: {
    paddingLeft: 12,
    position: "relative",
    top: 1,
    [theme.breakpoints.down("xs")]: {
      lineHeight: 1
    },
    "&.trainerGroupName": {
      paddingLeft: 6
    }
  },
  ruleGroupName: {},
  dots: {
    flex: "1 0 20px",
    borderBottom: "1px dashed #d0d0d0",
    margin: "0 4px"
  },
  groupCondition: {
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: "nowrap"
  },
  additionalDetails: {
    fontWeight: 600,
    lineHeight: 1,
    marginTop: 8
  },
  note: {
    lineHeight: 1,
    fontSize: 12,
    marginTop: 2
  },
  raceFooter: {
    marginTop: 8
  },
  matchesContainer: {
    display: "flex",
    marginTop: 10
  },
  matchesIndicator: {
    width: 18,
    height: 18,
    minWidth: 18,
    minHeight: 18,
    borderRadius: "50%",
    backgroundColor: "#f0e3bf",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#403d33",
    fontSize: 11,
    marginRight: 10
  },
  matchesIndicatorDisabled: {
    backgroundColor: "#eeeeee",
    color: theme.palette.text.disabled
  },
  horseLink: {
    marginRight: 4,
    whiteSpace: "nowrap",
    "&:hover": {
      cursor: "pointer"
    }
  },
  matchesIndicatorCounter: {},
  matchesTitle: {
    fontSize: 12,
    marginRight: 10
  },
  matchHorses: {
    fontSize: 12,
    display: "flex",
    textDecoration: "underline",
    flexWrap: "wrap"
  },
  raceDetailsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "sticky",
    top: 0,
    background: theme.palette.common.white,
    padding: 20,
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      padding: "14px 12px 10px 12px",
      boxShadow: "0px 2px 3px #eaeaea",
      height: RACE_DETAILS_HEADER_HEIGHT_XS
    }
  },
  raceDetailsMainHeader: {},
  raceDetailsMainTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: 18,
    fontWeight: 600,
    wordBreak: "break-all",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16
    }
  },
  longMainTitle: {
    fontSize: 14
  },
  raceDetailsSubTitle: {
    color: theme.palette.text.secondary,
    display: "none"
  },
  raceDetailsCloseContainer: {},
  closeButton: {
    padding: 0
  },
  closeButtonIcon: {},
  raceDetailsBody: {
    overflowX: "hidden",
    overflowY: "auto",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      height: "100%",
      maxHeight: `calc(100% - ${RACE_DETAILS_HEADER_HEIGHT_XS}px)`
    }
  },
  raceDetailsBodyTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 20,
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      padding: "12px"
    }
  },
  raceDetailsIndexContainer: {
    display: "flex",
    alignItems: "center"
  },
  raceDetailsIndex: {
    fontSize: 50,
    fontWeight: 600,
    marginRight: 10,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    height: 38
  },
  raceDetailsTitlesContainer: {
    fontSize: 14,
    lineHeight: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    height: 42
  },
  raceDetailsTitlesMain: {
    fontSize: 16,
    fontWeight: 600
  },
  raceDetailsTitlesSub: {},
  raceDetailsDataContainer: {
    fontSize: 13,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "flex-end",
    textAlign: "right"
  },
  raceDetailsRaceDate: {},
  raceDetailsRaceFacility: {
    fontWeight: 600,
    textTransform: "capitalize"
  },

  raceDetailsBodyCenter: {
    borderBottom: "1px solid #eeeeee"
  },
  challengeInfo: {
    padding: "10px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: "12px"
    }
  },
  challengeInfoContainer: {
    display: "flex"
  },
  challengeInfoIcon: {
    marginRight: 12
  },
  challengeInfoData: {
    paddingTop: 4,
    fontWeight: 600
  },
  challengeInfoName: {},
  challengeInfoPrice: {},
  challengeDetail: {
    display: "flex",
    alignItems: "center",
    marginTop: 4
  },
  challengeDetailTitle: {
    fontWeight: 600,
    marginRight: 6
  },
  challengeDetailValue: {},
  challengeImage: {
    maxWidth: 70
  },
  regularRaceInfo: {
    padding: "10px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: "12px"
    }
  },
  innerList: {
    overflowX: "hidden",
    overflowY: "auto",
    [theme.breakpoints.up("sm")]: {
      height: "calc(100dvh - 200px)"
    },
    [theme.breakpoints.up("lg")]: {
      height: "calc(100dvh - 230px)"
    },
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 8
    }
  },
  hiddenList: {
    display: "none"
  },
  genderGroup: {},
  genderGroupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px 14px 20px",
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      padding: "16px 16px 8px 16px",
      border: "none"
    }
  },
  genderGroupHeaderTitle: {
    fontSize: 16,
    fontWeight: 600
  },
  genderGroupHeaderExpandAll: {
    fontSize: 12,
    "&:hover": {
      cursor: "pointer"
    }
  },
  genderGroupBody: {
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px"
    }
  },
  ageGroup: {},
  ageGroupHeader: {},
  ageGroupBody: {},
  indexRaceData: {
    padding: 10,
    border: "1px solid #eeeeee",
    marginTop: 4,
    "&:nth-child(even)": {
      backgroundColor: "#eeeeee40"
    },
    "&:nth-child(odd)": {
      backgroundColor: "#eeeeee00"
    },
    "&.hasMatches": {
      borderColor: "#f0e3bf",
      backgroundColor: "#f0e3bf40"
    }
  },
  indexRaceDataHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: 600,
    marginBottom: 10,
    wordBreak: "break-all"
  },
  conditionsIcons: {
    display: "flex",
    alignItems: "center"
  },
  lastRaceIcon: {
    width: 30,
    height: 13,
    color: "#48769b"
  },
  customRaceIcon: {
    width: 30,
    height: 18,
    marginLeft: 2,
    color: "#998765",
    position: "relative",
    top: "1px"
  },
  indexRaceDataBody: {},
  distancesContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6
  },
  indexRaceDataDistance: {
    display: "flex",
    padding: "3px 0"
  },
  indexDistanceTitle: {
    fontSize: 12,
    minWidth: 40,
    height: 24,
    display: "flex",
    alignItems: "center"
  },
  indexDistanceValue: {
    width: 86,
    height: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 12,
    border: "1px solid rgba(255, 255, 255, 1)",
    borderRadius: 36,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.25)",
    padding: "0 2px",
    "&.indexDistanceHasMatches": {
      backgroundColor: "#f0e3bf"
    },
    "&:hover": {
      cursor: "pointer"
    },
    "&.selected": {
      borderColor: theme.palette.secondary.main,
      backgroundColor: theme.palette.secondary.main
    },
    "&.trainerIndexDistanceValue": {
      justifyContent: "flex-start"
    }
  },
  customMatchesCount: {
    width: 50
  },
  boldText: {
    fontWeight: 600
  },
  normalTextSize: {
    fontSize: 14
  },
  raceDetailsDescription: {
    color: theme.palette.text.secondary
  },
  rightPartPlaceholder: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  logoIcon: {
    position: "absolute",
    width: "80%",
    height: "380px",
    opacity: 0.03,
    color: "#333333"
  },
  rightPartPlaceholderText: {
    fontSize: 20,
    color: theme.palette.text.hint,
    textAlign: "center"
  },
  preferenceText: {
    fontSize: 12,
    marginTop: 6
  },
  swipeContainer: {
    height: "100%",
    "& .react-swipeable-view-container": {
      height: "100%"
    }
  },
  stateBredSiredIcon: {
    marginRight: 8,
    width: 40,
    height: 36
  }
}));
